import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { ValidatorOptions } from '../classes';
import { IValidatorError, IValidatorOptions } from '../interfaces';
import { DecoratedValidatorFunction } from '../types';

type ValidatorFactory = (...args: unknown[]) => unknown;

const validator = (
  originalMethodValidation: unknown,
  defaultFunction: ValidatorFactory,
  propertyKey: string,
  error: IValidatorError
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const result = typeof originalMethodValidation === 'function'
      ? (originalMethodValidation as ValidatorFn)(control)
      : defaultFunction(control);

    return result ? { [propertyKey]: error } : undefined;
  };
};

const ValidatorHandler = (
  options: IValidatorOptions,
  defaultFunction: ValidatorFactory,
  propertyKey: string
): DecoratedValidatorFunction => {
  return (...args: unknown[]): ValidatorFn => {
    const validatorOption = new ValidatorOptions(options);
    const originalMethodValidation = defaultFunction(...validatorOption.validatorParameters, ...args);
    const error = validatorOption.error || (args.pop() as { error: IValidatorError; }).error;

    return validator(originalMethodValidation, defaultFunction, propertyKey, error);
  };
};

export function Validator(defaultFunction: ValidatorFactory): PropertyDecorator;
export function Validator(defaultFunction: ValidatorFactory, options?: IValidatorOptions): PropertyDecorator {
  return (target: Record<string, DecoratedValidatorFunction>, propertyKey: string): void => {
    target[propertyKey] = ValidatorHandler(options, defaultFunction, propertyKey);
  };
}
